var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUk = function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E4E9D",
    d: "M0 0h16v12H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 10.438 10.083 6 16 1.563V0h-2.083L8 4.438 2.083 0H0v1.563L5.917 6 0 10.438V12h2.083L8 7.563 13.917 12H16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC251C",
    fillRule: "evenodd",
    d: "M0 0v.625L7.167 6 0 11.375V12h.833L8 6.625 15.167 12H16v-.625L8.833 6 16 .625V0h-.833L8 5.375.833 0z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6 4V0h4v4h6v4h-6v4H6V8H0V4z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC251C",
    fillRule: "evenodd",
    d: "M7 5V0h2v5h7v2H9v5H7V7H0V5z",
    clipRule: "evenodd"
  })));
};
export default SvgUk;